// useLayout() — единый адаптивный примитив (инв.3). Возвращает 'desktop' | 'mobile' по медиа-запросу
// ширины (дефолт-порог 768px, конфигурируем через параметр). На нём строятся: выбор раскладочного
// примитива (SplitPane vs StackPane), триггер контекст-меню (right-click vs long-press), размеры
// тач-таргетов. Компоненты сами не роутят — они лишь спрашивают режим.
//
// Презентационность: только подписка на matchMedia, без сети/стора.
import { useEffect, useState } from 'react';
/** Дефолтный порог desktop↔mobile (px). */
export const DEFAULT_LAYOUT_BREAKPOINT = 768;
/** Прочитать режим по порогу (SSR-safe: вне браузера → 'desktop'). */
function readLayout(breakpoint) {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return 'desktop';
    return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches ? 'mobile' : 'desktop';
}
/**
 * Текущий режим раскладки. Подписывается на смену ширины окна и переключается на лету.
 * @param breakpoint порог в px (ниже — mobile). По умолчанию 768.
 */
export function useLayout(breakpoint = DEFAULT_LAYOUT_BREAKPOINT) {
    const [mode, setMode] = useState(() => readLayout(breakpoint));
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
            return;
        const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const onChange = () => setMode(mq.matches ? 'mobile' : 'desktop');
        onChange();
        if (typeof mq.addEventListener === 'function') {
            mq.addEventListener('change', onChange);
            return () => mq.removeEventListener('change', onChange);
        }
        mq.addListener(onChange);
        return () => mq.removeListener(onChange);
    }, [breakpoint]);
    return mode;
}
/** Минимальный тач-таргет на mobile (px) — инв.3 (≥44px). */
export const MIN_TOUCH_TARGET_PX = 44;
//# sourceMappingURL=useLayout.js.map